import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationNone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAnimationNone"><Path fillRule="evenodd" clipRule="evenodd" d="M11 3H21V5H13V21H3V19H11V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAnimationNone;
